import Typography from '@mui/material/Typography'

const P = ({children, ...props}) => <Typography component="p" variant="p" {...props}>{children}</Typography>
export const Strong = ({children, ...props}) => <Typography component="strong" variant="strong" {...props}>{children}</Typography>
export const Span = ({children, ...props}) => <Typography component="span" variant="span" {...props}>{children}</Typography>
export const ErrorSpan = ({ children, ...props }) => (
    <Typography component="span" variant="span" {...props} color="error.main">
        {children}
    </Typography>
);
export const MenuError = ({ children, label='', disabled = false, ...props }) => (
    <Span>
        {label}
        {disabled && (
            <>
                &nbsp;&nbsp;<ErrorSpan className="fs-10" {...props} color="error.main">
                    {children}
                </ErrorSpan>
            </>
        )}
    </Span>
);

export default P;